import { defaultStockLocationId } from '@/warehouse/constants';
import { appLocalStorage } from './appLocalStorage';
/**
 * Gets current stockLocationId from localStorage.
 */
export function getStockLocationId() {
    const value = appLocalStorage.getItem('stockLocationId');
    return value === null ? defaultStockLocationId : Number(value);
}
